(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fk-home-redesign"] && !Shopify.designMode) return;
  try {
    
(function(){
  const root=document.getElementById('fk-home-redesign');
  if(!root||root.dataset.initialized)return;
  root.dataset.initialized='true';
  root.querySelectorAll('.tab').forEach(button=>button.addEventListener('click',()=>{root.querySelectorAll('.tab').forEach(t=>{const active=t===button;t.classList.toggle('active',active);t.setAttribute('aria-selected',active)});root.querySelectorAll('.product-panel').forEach(panel=>{const active=panel.id===button.dataset.tab;panel.classList.toggle('active',active);panel.hidden=!active})}));
    const carousel=root.querySelector('#bannerCarousel'),track=root.querySelector('#bannerTrack'),slides=[...track.querySelectorAll('.banner-slide')],dots=[...root.querySelectorAll('#bannerDots button')],count=root.querySelector('#bannerCount');
    if(!slides.length)return;
    const firstClone=slides[0].cloneNode(true),lastClone=slides[slides.length-1].cloneNode(true);
    [firstClone,lastClone].forEach(clone=>{clone.setAttribute('aria-hidden','true');clone.tabIndex=-1});
    track.prepend(lastClone);track.append(firstClone);
    let bannerIndex=0,trackIndex=1,bannerTimer,bannerSettleTimer,animating=false,pointerStart=null,dragging=false,suppressClick=false;
    function updateBannerUi(){[...track.children].forEach((slide,i)=>slide.classList.toggle('is-active',i===trackIndex));slides.forEach((slide,i)=>slide.tabIndex=i===bannerIndex?0:-1);dots.forEach((dot,i)=>{dot.classList.toggle('active',i===bannerIndex);if(i===bannerIndex)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current')});count.textContent=String(bannerIndex+1).padStart(2,'0')+' / '+String(slides.length).padStart(2,'0')}
    function positionBanner(animated=true,offset=0){track.style.transition=animated&&!matchMedia('(prefers-reduced-motion: reduce)').matches?'':'none';track.style.transform='translate3d(calc(-'+(trackIndex*100)+'% + '+offset+'px),0,0)'}
    function stopBanner(){clearInterval(bannerTimer)}
    function startBanner(){stopBanner();if(!matchMedia('(prefers-reduced-motion: reduce)').matches)bannerTimer=setInterval(()=>goBanner(1),4500)}
    function goBanner(delta){if(animating)return;animating=true;trackIndex+=delta;bannerIndex=(bannerIndex+delta+slides.length)%slides.length;updateBannerUi();void track.offsetWidth;positionBanner();if(matchMedia('(prefers-reduced-motion: reduce)').matches)finishBanner();else bannerSettleTimer=setTimeout(finishBanner,650)}
    function chooseBanner(index){if(animating||index===bannerIndex)return;animating=true;trackIndex=index+1;bannerIndex=index;updateBannerUi();positionBanner();if(matchMedia('(prefers-reduced-motion: reduce)').matches)finishBanner();else bannerSettleTimer=setTimeout(finishBanner,650)}
    function finishBanner(){if(!animating)return;clearTimeout(bannerSettleTimer);if(trackIndex===0)trackIndex=slides.length;if(trackIndex===slides.length+1)trackIndex=1;positionBanner(false);updateBannerUi();animating=false}
    track.addEventListener('transitionend',event=>{if(event.target===track&&event.propertyName==='transform')finishBanner()});
    root.querySelector('#bannerPrev').addEventListener('click',()=>{goBanner(-1);startBanner()});
    root.querySelector('#bannerNext').addEventListener('click',()=>{goBanner(1);startBanner()});
    dots.forEach((dot,i)=>dot.addEventListener('click',()=>{chooseBanner(i);startBanner()}));
    carousel.addEventListener('dragstart',event=>event.preventDefault());
    carousel.addEventListener('pointerdown',event=>{if(event.button!==0||animating)return;stopBanner();pointerStart={x:event.clientX,y:event.clientY,id:event.pointerId};dragging=false;carousel.setPointerCapture(event.pointerId)});
    carousel.addEventListener('pointermove',event=>{if(!pointerStart||event.pointerId!==pointerStart.id)return;const dx=event.clientX-pointerStart.x,dy=event.clientY-pointerStart.y;if(!dragging&&Math.abs(dx)>8&&Math.abs(dx)>Math.abs(dy))dragging=true;if(dragging){carousel.classList.add('is-dragging');positionBanner(false,dx);event.preventDefault()}});
    carousel.addEventListener('pointerup',event=>{if(!pointerStart||event.pointerId!==pointerStart.id)return;const dx=event.clientX-pointerStart.x;if(dragging){suppressClick=true;setTimeout(()=>suppressClick=false,400);carousel.classList.remove('is-dragging');if(Math.abs(dx)>Math.min(80,carousel.clientWidth*.12))goBanner(dx<0?1:-1);else{void track.offsetWidth;positionBanner()}}pointerStart=null;dragging=false;startBanner()});
    carousel.addEventListener('pointercancel',()=>{pointerStart=null;dragging=false;carousel.classList.remove('is-dragging');positionBanner();startBanner()});
    carousel.addEventListener('click',event=>{if(suppressClick){event.preventDefault();event.stopPropagation();suppressClick=false;return}const side=event.target.closest('.banner-slide');if(side){const sideIndex=[...track.children].indexOf(side);if(sideIndex!==trackIndex){event.preventDefault();goBanner(sideIndex<trackIndex?-1:1);startBanner()}}},true);
    carousel.addEventListener('mouseenter',stopBanner);carousel.addEventListener('mouseleave',()=>{if(!pointerStart)startBanner()});carousel.addEventListener('focusin',stopBanner);carousel.addEventListener('focusout',startBanner);
    carousel.addEventListener('keydown',event=>{if(event.key==='ArrowRight'){goBanner(1);event.preventDefault()}if(event.key==='ArrowLeft'){goBanner(-1);event.preventDefault()}});
    updateBannerUi();positionBanner(false);startBanner();
    const allCategoryToggle=root.querySelector('#allCategoryToggle'),allCategoryList=root.querySelector('#allCategoryList');
    allCategoryToggle.addEventListener('click',()=>{const open=allCategoryList.hidden;allCategoryList.hidden=!open;allCategoryToggle.setAttribute('aria-expanded',open);allCategoryToggle.innerHTML=open?'カテゴリーを閉じる <span aria-hidden="true">−</span>':'すべてのカテゴリーを見る <span aria-hidden="true">＋</span>'});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
